import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  root: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    gap: theme.spacing(2),
    alignItems: 'center',
  },
}));
